'use strict';
var autocomplete = require('./../autocomplete');
var addressservice = require('./addressservice');

module.exports = {

    ////////
    //////
    //  ADDRESS FUNCTIONALITY
    //////
    ////////

    //user has changed the city selection from dropdown
    countryChange: function countryChange(countryVal, stateObj, cityObj, zipObj) {

        var self = this;

        //self.debug('countryChange()');

        //get list of states if US selected and there isn't already a list of states
        if (countryVal === 'US' && stateObj.allstates.length < 1) {
            self.getStates(stateObj);
        }
        else {
            stateObj.value = '';
            cityObj.value = '';
            zipObj.value = '';
        }

    },
    //user has changed the state selection from dropdown
    stateChange: function stateChange(cityObj, stateVal, zipObj) {

        var self = this;

        //reset city and zip values
        cityObj.value = '';
        zipObj.value = '';

        //get cities for selected state
        self.getCities(cityObj, stateVal);
    },

    //////
    //  EVENT HANDLERS - AUTO COMPLETE

    autoCompleteSetResult: function autoCompleteSetResult(obj, fieldVal, zipObj, countryVal, cityVal, stateVal) {

        var self = this;

        //close autocomplete box and set the selected value
        obj.isopen = false;
        obj.arrowcounter = -1;
        obj.value = fieldVal;

        //reset options to full list (in case user comes back to change the value)
        obj.search = obj.allvalues;

        if (countryVal === 'US') {

            //if the city is being set
            if (obj.name === "Address.City") {

                //get a list of zipcodes that are in city
                self.getZipCodes(zipObj, cityVal, stateVal);

                //if new city does not contain existing zipcode as option, blank it
                if (zipObj.allvalues.indexOf(zipObj.value) === -1) {
                    zipObj.value = '';
                }
            }
        }
    },

    clickOutFilter: function clickOutFilter(e, cityObj, zipObj) {

        var validElements = ['li', 'ul', 'input'];

        console.log('clickout firing');

        if (validElements.indexOf(e.target.tagName) === -1) {

            cityObj.isopen = false;
            cityObj.arrowCounter = -1;
            cityObj.search = cityObj.allvalues;

            zipObj.isopen = false;
            zipObj.arrowcounter = -1;
            zipObj.search = zipObj.allvalues;
        }
    },

    ////////
    //////
    //  AJAX REQUESTS
    //////
    ////////

    getCountries: function getCountries(countryObj) {

        addressservice.getCountries().then(function (data) {
            countryObj.allcountries = data;
        });
    },
    getStates: function getStates(stateObj) {

        addressservice.getStates().then(function (data) {
            stateObj.allstates = data;
            stateObj.search = data;
        });
    },
    getCities: function getCities(cityObj, stateVal) {

        addressservice.getCities(stateVal).then(function (data) {
            cityObj.allvalues = data;
        });
    },
    getZipCodes: function getZipCodes(zipObj, cityVal, stateVal) {

        addressservice.getZipCodes(stateVal, cityVal).then(
            function (data) {
                zipObj.allvalues = data;
            });
    }
}